import { SetStateAction, useEffect } from 'react';
import { FieldValues, UseFormSetError } from 'react-hook-form';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import {
  isErrorWithObjectMessage,
  isErrorWithStringMessage,
} from '@redux/baseQuery';
import { assignFormErrors } from '@utils/form';

export const useFormErrors = ({
  isError,
  error,
  setError,
  setErrorMessage,
  errorMessage = 'Invalid data',
}: {
  isError: boolean;
  error?: FetchBaseQueryError | SerializedError;
  setError: UseFormSetError<FieldValues>;
  setErrorMessage?: (errorMessage: SetStateAction<string>) => void;
  errorMessage?: string;
}) => {
  useEffect(() => {
    if (isError && isErrorWithObjectMessage(error)) {
      assignFormErrors(setError, error);
      return;
    }

    if (isError && isErrorWithStringMessage(error) && setErrorMessage) {
      setErrorMessage(
        (error.data! as { message: string }).message || errorMessage,
      );
      return;
    }

    if (isError && setErrorMessage) {
      setErrorMessage('Network request failed. Please, try again later');
    }
  }, [isError, error, setError, setErrorMessage, errorMessage]);
};
